import styled from 'styled-components';
import media from 'styles/media';
import { PillButton } from '@rcg/ui-components';
import { SectionTitle } from 'components/FiltersModal/components';

export const Calendar = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  ${media.small`
    flex-direction: column;
  `}

  width: 100%;
  min-height: 210px;
`;

export const YearWrapper = styled.div`
  position: absolute;
  top: 0;
  left: calc(${props => props.index} * 33.3333%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin-bottom: 40px;
  width: 33.3333%;
  padding: 0 20px 40px;

  opacity: 0;

  ${media.medium`
    width: 50%;
    left: calc(${props => props.index} * 50%);
  `}

  ${media.small`
    margin: 0 0 40px;
    width: 100%;
    position: relative;
    left: unset;
    padding: 0;
  `}
`;

export const MonthsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: ${({ gap }) => gap};
  width: 100%;
`;

export const YearLabel = styled(SectionTitle)`
  &.yearLabel {
    text-align: center;

    ${media.small`
      margin-bottom: 27px;
      text-align: left;
    `}
  }
`;

export const MonthTile = styled.div`
  button{
    text-transform: capitalize;
  }
`;

export const MonthButton = styled(PillButton)`
  ${media.medium`
    max-width: unset;
  `}

  ${media.small`
    height: 50px;
    width: 95%;
  `}

  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth};

  &.disabled {
    pointer-events: none;
    opacity: 0.4;
  }

  &.disabled-facet {
    pointer-events: none;
    opacity: 0.4;
  }

  &.unclickable {
    pointer-events: none;
  }
`;
